import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';
import { ClinicMedService, DataSourceResponse } from '../../models';


@Injectable({ providedIn: 'root' })
export class ClinicMedServicesService extends ApiService {
  endPoint = '/api/clinicmedservices';
  create(model: ClinicMedService) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: ClinicMedService) {
    return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<ClinicMedService> {
    return this.http.get<ClinicMedService>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<ClinicMedService>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }
  getAll(queryParams: any): Observable<DataSourceResponse<ClinicMedService>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }
  getForEmployee(employeeId: string): Observable<ClinicMedService[]> {
    return this.http.get<ClinicMedService[]>(`${this.clinicsBaseURL}${this.endPoint}/ForEmployee/${employeeId}`);
  }
}
